import Statistics from "../../pages/home/statistics/Statistics";
import ProjectInformation from "../../pages/home/information/ProjectInformation";
import CreateProjectInformation from "../../pages/home/information/CreateProjectInformation";
import TrackProjectStatus from "../../pages/home/track-project-status/TrackProjectStatus";
import UsageStatistics from "../../pages/home/statistics-usage/UsageStatistics";
import ViewTrackProjectStatus from "../../pages/home/track-project-status/view-project/ViewTrackProjectStatus";
import Notification from "../../pages/home/notification/Notification";

// รายงาน
import Report from '../../pages/home/report/Report'
import EquipmentAccount from "../../pages/home/report/equipmentAccount/EquipmentAccount";
import ReportShowingOperational from "../../pages/home/report/operational/ReportShowingOperational";
import BudgerSpendingReport from "../../pages/home/report/budgetSpending/BudgetSpendingReport";
import ProjectSuccess from "../../pages/home/report/projectSuccess/ProjectSuccess";
import ProjectProgressReport from "../../pages/home/report/projectProgress/ProjectProgressReport";

// ตั้งค่า
import FiscalYear from "../../pages/home/setting/fiscal-year/FiscalYear";
import PlanSetting from "../../pages/home/setting/plan/PlanSetting";
import BudgetSource from "../../pages/home/setting/budget-source/BudgetSource";
// import AgencyInformation from "../../pages/home/setting/agency-information/AgencyInformation";
import DetailAgency from "../../pages/home/setting/agency-information/DetailAgency";
import CustomizeSetting from "../../pages/home/setting/customize/CustomizeSetting";
import PermissionSetting from "../../pages/home/setting/permission/PermissionSetting";
import PermissionDetail from "../../pages/home/setting/permission/detail/PermissionDetail";
import SystemUsers from "../../pages/home/setting/system-users/SystemUsers";
import ManageRole from "../../pages/home/setting/manage-role/ManageRole";

// SUB MENU ปีงบประมาณ
import Strategic from "../../pages/home/setting/fiscal-year/strategic/Strategic";
import Tactics from "../../pages/home/setting/fiscal-year/strategic/tactics/Tactics";
import MissionType from "../../pages/home/setting/fiscal-year/mission-type/MissionType";
import ProjectProgressSetting from "../../pages/home/setting/fiscal-year/project-progress/ProjectProgressSetting";
import NotificationSetting from "../../pages/home/setting/fiscal-year/notification/NotificationSetting";
import ProjectTypeSetting from "../../pages/home/setting/fiscal-year/project-type/ProjectTypeSetting";

import UpdateProjectInformation from "../../pages/home/information/UpdateProjectInformation";
import ViewProjectInformation from "../../pages/home/information/ViewProjectInformation";
import EditTrackingProjectStatus from "../../pages/home/track-project-status/view-project/EditTrackingProject";
import DepartmentList from "../../pages/home/setting/agency-information/DepartmentList";
import TrackingSummary from "../../pages/home/report/TrackingSummary/TrackingSummary";
import ReportSummary from "../../pages/home/report/TrackingSummary/report/ReportSummary";
import ReportSummaryStrategy from "../../pages/home/report/TrackingSummary/report/ReportSummaryStrategy";
import ReportEquipments from "../../pages/home/report/equipmentAccount/report/ReportEquipments";
import ReportEquipmentOther from "../../pages/home/report/equipmentAccount/report/ReportEquipmentOther";
import ProgressReport from "../../pages/home/report/operational/report/ProgressReport";
import BudgetReport from "../../pages/home/report/budgetSpending/report/BudgetReport";
import EvaluationReport from "../../pages/home/report/projectSuccess/report/EvaluationReport";
import ColorfulReport from "../../pages/home/report/projectProgress/report/ColorfulReport";

type pathProps = {
    reportPath: string;
    settingPath: string;
}
const path: pathProps = {
    reportPath: "report",
    settingPath: '/auth/setting'
}


interface routes {
    key: string;
    path: string;
    labelNameEn: string;
    labelNameTh: string;
    component: React.ComponentType;
    code?: string;
    permit: boolean;
}

export const homeRoute: routes[] = [
    // สถิติข้อมูล
    {
        key: "HOME_STATISTICS",
        path: "/auth/statistics",
        labelNameEn: "Statistics",
        labelNameTh: "สถิติข้อมูล",
        component: Statistics,
        code: "Statistics.Open",
        permit: true,
    },

    // ข้อมูลโครงการ
    {
        key: "HOME_PROJECT_INFORMATION",
        path: "/auth/project-information",
        labelNameEn: "Project information",
        labelNameTh: "ข้อมูลโครงการ",
        component: ProjectInformation,
        code: "ProjectInformation.Open",
        permit: true
    },
    {
        key: "HOME_PROJECT_INFORMATION-CREATE-PROJECT",
        path: "/auth/project-information/create",
        labelNameEn: "Create project information",
        labelNameTh: "สร้างโปรเจค",
        component: CreateProjectInformation,
        permit: true
    },
    {
        key: "HOME_PROJECT_INFORMATION-UPDATE-PROJECT",
        path: "/auth/project-information/update/:idProject",
        labelNameEn: "Update project information",
        labelNameTh: "อัพเดตรายละเอียดโปรเจ็ค",
        component: UpdateProjectInformation,
        permit: true
    },
    {
        key: "HOME_PROJECT_INFORMATION-UPDATE-PROJECT",
        path: "/auth/project-information/view/:idProject",
        labelNameEn: "Update project information",
        labelNameTh: "ดูรายละเอียดโปรเจ็ค",
        component: ViewProjectInformation,
        permit: true
    },

    // รายงาน
    {
        key: "HOME_PROJECT_REPORT",
        path: `/auth/${path.reportPath}`,
        labelNameEn: "Report information",
        labelNameTh: "รายงาน",
        component: Report,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_TRACKING_SUMMARY",
        path: `/auth/${path.reportPath}/tracking-summary-account`,
        labelNameEn: "TrackingSummary",
        labelNameTh: "บัญชีสรุปผลการติดตาม",
        component: TrackingSummary,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_TRACKING_SUMMARY_REPORT",
        path: `/auth/${path.reportPath}/tracking-summary-account/report`,
        labelNameEn: "Report 1 TrackingSummary",
        labelNameTh: "รายงาน 1 บัญชีสรุปผลการติดตาม",
        component: ReportSummary,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_TRACKING_SUMMARY_REPORT_NOT_ALL",
        path: `/auth/${path.reportPath}/tracking-summary-account/report-strategy`,
        labelNameEn: "Report 2 TrackingSummary",
        labelNameTh: "รายงาน 2 บัญชีสรุปผลการติดตาม",
        component: ReportSummaryStrategy,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_EQUIPMENT_ACCOUNT",
        path: `/auth/${path.reportPath}/equipment-account`,
        labelNameEn: "EquipmentAccount",
        labelNameTh: "บัญชีครุภัณฑ์",
        component: EquipmentAccount,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_EQUIPMENT_ACCOUNT_REPORT1",
        path: `/auth/${path.reportPath}/equipment-account/reports`,
        labelNameEn: "EquipmentAccount report1",
        labelNameTh: "บัญชีครุภัณฑ์รวม",
        component: ReportEquipments,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_EQUIPMENT_ACCOUNT_REPORT2",
        path: `/auth/${path.reportPath}/equipment-account/report`,
        labelNameEn: "EquipmentAccount report2",
        labelNameTh: "บัญชีครุภัณฑ์ แยกตามครุภัณฑ์",
        component: ReportEquipmentOther,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_SHOWING_OPERATIONAL",
        path: `/auth/${path.reportPath}/operational-achievements`,
        labelNameEn: "ReportShowingOperational",
        labelNameTh: "ผลสัมฤทธิ์การดำเนินงาน",
        component: ReportShowingOperational,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_SHOWING_OPERATIONAL_REPORT",
        path: `/auth/${path.reportPath}/operational-achievements/report`,
        labelNameEn: "ReportShowingOperational report1",
        labelNameTh: "ผลสัมฤทธิ์การดำเนินงาน รานงาน 1",
        component: ProgressReport,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_BUDGET_SPENDING",
        path: `/auth/${path.reportPath}/budget-spending`,
        labelNameEn: "BudgetSpendingReport",
        labelNameTh: "รายงานผลการใช้จ่ายงบประมาณ",
        component: BudgerSpendingReport,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_BUDGET_SPENDING_REPORT",
        path: `/auth/${path.reportPath}/budget-spending/report`,
        labelNameEn: "BudgetSpendingReport report",
        labelNameTh: "รายงานผลการใช้จ่ายงบประมาณ รายงาน",
        component: BudgetReport,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_PROJECT_SUCCESS",
        path: `/auth/${path.reportPath}/project-success`,
        labelNameEn: "ProjectSuccess",
        labelNameTh: "ความสำเร็จของโครงการ",
        component: ProjectSuccess,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_PROJECT_SUCCESS_REPORT",
        path: `/auth/${path.reportPath}/project-success/report`,
        labelNameEn: "ProjectSuccess report1",
        labelNameTh: "ความสำเร็จของโครงการ รายงาน1",
        component: EvaluationReport,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_PROJECT_PROGRESS",
        path: `/auth/${path.reportPath}/project-progress`,
        labelNameEn: "ProjectProgressReport",
        labelNameTh: "รายงานความคืบหน้าโครงการ",
        component: ProjectProgressReport,
        permit: true
    },
    {
        key: "HOME_PROJECT_REPORT_PROJECT_PROGRESS_COLORFUL",
        path: `/auth/${path.reportPath}/project-progress/colorful-report`,
        labelNameEn: "ProjectProgressReport colorful",
        labelNameTh: "รายงานความคืบหน้าโครงการ 5 ระดับสี",
        component: ColorfulReport,
        permit: true
    },


    {
        key: "HOME_PROJECT_TRACK_PROJECT_STATUS",
        path: "/auth/project-status",
        labelNameEn: "Track project status",
        labelNameTh: "ติดตามสถานะโครงการ",
        component: TrackProjectStatus,
        permit: true
    },
    {
        key: "HOME_PROJECT_TRACK_PROJECT_STATUS2_VIEW",
        path: "/auth/project-status/view",
        labelNameEn: "Track project status",
        labelNameTh: "ติดตามสถานะโครงการ(รายละเอียด)",
        component: ViewTrackProjectStatus,
        permit: true
    },
    {
        key: "HOME_PROJECT_TRACK_PROJECT_STATUS2_EDIT",
        path: "/auth/project-status/edit/:idProject",
        labelNameEn: "Track project status",
        labelNameTh: "ติดตามสถานะโครงการ(แก้ไข)",
        component: EditTrackingProjectStatus,
        permit: true
    },
    {
        key: "HOME_PROJECT_TRACK_PROJECT_STATUS",
        path: "/auth/usage-statistics",
        labelNameEn: "Track project status",
        labelNameTh: "สถิติการใช้งาน",
        component: UsageStatistics,
        permit: true
    },


    // ตั้งค่า
    {
        key: "HOME_PROJECT_SETTING_FISCALYEAR",
        path: `${path.settingPath}/fiscal-year`,
        labelNameEn: "Fiscal year",
        labelNameTh: "ปีงบประมาณ",
        component: FiscalYear,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_STRATEGIC",
        path: `${path.settingPath}/strategic`,
        labelNameEn: "Strategic",
        labelNameTh: "ยุทธศาสตร์",
        component: Strategic,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_STRATEGIC",
        path: `${path.settingPath}/tactics`,
        labelNameEn: "Tactics",
        labelNameTh: "กลยุทธ์",
        component: Tactics,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_MISSION_TYPE",
        path: `${path.settingPath}/mission-type`,
        labelNameEn: "Missiontype",
        labelNameTh: "ประเภทภารกิจ",
        component: MissionType,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_PROJECT_PROGRESS",
        path: `${path.settingPath}/project-progress`,
        labelNameEn: "ProjectProgress",
        labelNameTh: "ความคืบหน้าโครงการ",
        component: ProjectProgressSetting,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_NOTIFICATION",
        path: `${path.settingPath}/notification`,
        labelNameEn: "Notifications",
        labelNameTh: "การแจ้งเตือน",
        component: NotificationSetting,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_PROJECT_TYPE",
        path: `${path.settingPath}/project-type`,
        labelNameEn: "ProjectType",
        labelNameTh: "ประเภทโครงการ",
        component: ProjectTypeSetting,
        permit: true
    },
    // {
    //     key: "HOME_PROJECT_SETTING_PROJECT_TYPE",
    //     path: `${path.settingPath}/operation`,
    //     labelNameEn: "OperationSteps",
    //     labelNameTh: "ขั้นตอนการดำเนินการโครงการ",
    //     component: OperationSteps,
    //     permit: true
    // },
    {
        key: "HOME_PROJECT_SETTING_SYSTEM_USERS",
        path: `${path.settingPath}/system-users`,
        labelNameEn: "SystemUsers",
        labelNameTh: "จัดการผู้ใช้งาน",
        component: SystemUsers,
        permit: true
    },

    {
        key: "HOME_PROJECT_SETTING_PLANE",
        path: `${path.settingPath}/plan`,
        labelNameEn: "Plan",
        labelNameTh: "แผนงาน",
        component: PlanSetting,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_BUDGET_SOURCE",
        path: `${path.settingPath}/budget-source`,
        labelNameEn: "Budget-Source",
        labelNameTh: "แหล่งที่มาของงบประมาณ",
        component: BudgetSource,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_AGENCY",
        path: `${path.settingPath}/agency`,
        labelNameEn: "Agency",
        labelNameTh: "หน่วยงาน",
        component: DetailAgency,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_AGENCY_DETAIL",
        path: `${path.settingPath}/agency/detail/:idDepartmentProps`,
        labelNameEn: "Detail Agency",
        labelNameTh: "ข้อมูลหน่วยงาน",
        component: DepartmentList,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_PERMISSION",
        path: `${path.settingPath}/permission`,
        labelNameEn: "Permission",
        labelNameTh: "จัดการบทบาท",
        component: PermissionSetting,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_MANAGE_ROLE",
        path: `${path.settingPath}/manage-role`,
        labelNameEn: "ManageRole",
        labelNameTh: "จัดการบทบาท",
        component: ManageRole,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_PERMISSION_DETAIL",
        path: `${path.settingPath}/permission/detail/:id`,
        labelNameEn: "Permission Detail",
        labelNameTh: "รายละเอียดการกำหนดสิทธิ์",
        component: PermissionDetail,
        permit: true
    },
    {
        key: "HOME_PROJECT_SETTING_CUSTOMIZE",
        path: `${path.settingPath}/customize`,
        labelNameEn: "Customize.Open",
        labelNameTh: "ปรับแต่ง",
        component: CustomizeSetting,
        code: "Customize",
        permit: true
    },


    // การแจ้งเตือน
    {
        key: "HOME_NOTIFICATION",
        path: `/auth/notification`,
        labelNameEn: "Notification",
        labelNameTh: "แจ้งเตือน",
        component: Notification,
        permit: true
    },
]

